import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { outboundMessagesAnalyticsClient } from '~/services';
import { catchRequestError } from '../../utils/request';

export const useAnalyticsTargets = createGlobalState(() => {
    const loading = ref(false);
    const targets = ref({});
    const error = ref();

    const fetchTargets = async (teamId) => {
        error.value = '';
        loading.value = true;

        try {
            const response = await outboundMessagesAnalyticsClient.getCategoryPerformanceTargets({ teamId });
            targets.value = response?.data?.targets;
        } catch (e) {
            error.value = catchRequestError(e);
        } finally {
            loading.value = false;
        }
    };

    const getMetricTarget = (category, metric) => targets.value[category]?.[metric] || null;

    return {
        loading,
        error,
        targets,
        getMetricTarget,
        fetchTargets,
    };
});
